import { render, staticRenderFns } from "./Request2FA.vue?vue&type=template&id=15075476"
import script from "./Request2FA.vue?vue&type=script&lang=js"
export * from "./Request2FA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports